// package: membership
// file: membership/model.proto

import * as quest_model from "../quest/model";
import * as user_base_model from "../user/base/model";

export const MembershipInfoV2 = {
    encode(object) {
        const message = {};
        if (object.userID != null) {
            if (object.userID !== "") {
                message.userID = String(object.userID);
            }
        }
        if (object.status != null) {
            if (object.status !== 0) {
                message.status = object.status;
            }
        }
        if (object.openedTime != null) {
            if (object.openedTime !== 0) {
                message.openedTime = String(object.openedTime);
            }
        }
        if (object.expiredTime != null) {
            if (object.expiredTime !== 0) {
                message.expiredTime = String(object.expiredTime);
            }
        }
        if (object.expiredDays != null) {
            if (object.expiredDays !== 0) {
                message.expiredDays = String(object.expiredDays);
            }
        }
        if (object.memberPrice != null) {
            message.memberPrice = MemberPriceV2.encode(object.memberPrice);
        }
        if (object.isNewUser != null) {
            if (object.isNewUser !== false) {
                message.isNewUser = Boolean(object.isNewUser);
            }
        }
        if (object.isShowDiscount85 != null) {
            if (object.isShowDiscount85 !== false) {
                message.isShowDiscount85 = Boolean(object.isShowDiscount85);
            }
        }
        if (object.isHasAnnualCardPermission != null) {
            if (object.isHasAnnualCardPermission !== false) {
                message.isHasAnnualCardPermission = Boolean(object.isHasAnnualCardPermission);
            }
        }
        if (object.annualCardExpiredTime != null) {
            if (object.annualCardExpiredTime !== 0) {
                message.annualCardExpiredTime = String(object.annualCardExpiredTime);
            }
        }
        if (object.isNewUserV3 != null) {
            if (object.isNewUserV3 !== false) {
                message.isNewUserV3 = Boolean(object.isNewUserV3);
            }
        }
        if (object.isNewUserV4 != null) {
            if (object.isNewUserV4 !== false) {
                message.isNewUserV4 = Boolean(object.isNewUserV4);
            }
        }
        if (object.isOpenedContinuousMonth != null) {
            if (object.isOpenedContinuousMonth !== false) {
                message.isOpenedContinuousMonth = Boolean(object.isOpenedContinuousMonth);
            }
        }
        if (object.isPostponedCycleContract != null) {
            if (object.isPostponedCycleContract !== false) {
                message.isPostponedCycleContract = Boolean(object.isPostponedCycleContract);
            }
        }
        if (object.familyInfo != null) {
            message.familyInfo = FamilyInfoV2.encode(object.familyInfo);
        }
        if (object.currentValidityStartTime != null) {
            if (object.currentValidityStartTime !== 0) {
                message.currentValidityStartTime = String(object.currentValidityStartTime);
            }
        }
        if (object.firstOpenAnnualCardMembershipTime != null) {
            if (object.firstOpenAnnualCardMembershipTime !== 0) {
                message.firstOpenAnnualCardMembershipTime = String(object.firstOpenAnnualCardMembershipTime);
            }
        }
        if (object.isHasFreeCardPermission != null) {
            if (object.isHasFreeCardPermission !== false) {
                message.isHasFreeCardPermission = Boolean(object.isHasFreeCardPermission);
            }
        }
        if (object.freeCardExpiredTime != null) {
            if (object.freeCardExpiredTime !== 0) {
                message.freeCardExpiredTime = String(object.freeCardExpiredTime);
            }
        }
        if (object.canClaimFreeCard != null) {
            if (object.canClaimFreeCard !== false) {
                message.canClaimFreeCard = Boolean(object.canClaimFreeCard);
            }
        }
        if (object.isStreamerMembership != null) {
            if (object.isStreamerMembership !== false) {
                message.isStreamerMembership = Boolean(object.isStreamerMembership);
            }
        }
        if (object.freeCardType != null) {
            if (object.freeCardType !== 0) {
                message.freeCardType = object.freeCardType;
            }
        }
        if (object.membershipRedPacketType != null) {
            if (object.membershipRedPacketType !== 0) {
                message.membershipRedPacketType = object.membershipRedPacketType;
            }
        }
        if (object.doesHavePhoneBillClaimPermission != null) {
            if (object.doesHavePhoneBillClaimPermission !== false) {
                message.doesHavePhoneBillClaimPermission = Boolean(object.doesHavePhoneBillClaimPermission);
            }
        }
        if (object.membershipAttrs != null) {
            message.membershipAttrs = MembershipAttrs.encode(object.membershipAttrs);
        }
        if (object.canBuySaveMoneyCard != null) {
            if (object.canBuySaveMoneyCard !== false) {
                message.canBuySaveMoneyCard = Boolean(object.canBuySaveMoneyCard);
            }
        }
        if (object.isSaveMoneyCardPermission != null) {
            if (object.isSaveMoneyCardPermission !== false) {
                message.isSaveMoneyCardPermission = Boolean(object.isSaveMoneyCardPermission);
            }
        }
        if (object.isSaveMoneyCardElemeMembershipType != null) {
            if (object.isSaveMoneyCardElemeMembershipType !== false) {
                message.isSaveMoneyCardElemeMembershipType = Boolean(object.isSaveMoneyCardElemeMembershipType);
            }
        }
        if (object.nextPayIsFirstRenewal != null) {
            if (object.nextPayIsFirstRenewal !== false) {
                message.nextPayIsFirstRenewal = Boolean(object.nextPayIsFirstRenewal);
            }
        }
        if (object.renewalTimes != null) {
            if (object.renewalTimes !== 0) {
                message.renewalTimes = String(object.renewalTimes);
            }
        }
        if (object.maxRenewalTimesAllowed != null) {
            if (object.maxRenewalTimesAllowed !== 0) {
                message.maxRenewalTimesAllowed = String(object.maxRenewalTimesAllowed);
            }
        }
        if (object.isQuickSaveMoneyCardPermission != null) {
            if (object.isQuickSaveMoneyCardPermission !== false) {
                message.isQuickSaveMoneyCardPermission = Boolean(object.isQuickSaveMoneyCardPermission);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            userID: "",
            status: 0,
            openedTime: 0,
            expiredTime: 0,
            expiredDays: 0,
            memberPrice: null,
            isNewUser: false,
            isShowDiscount85: false,
            isHasAnnualCardPermission: false,
            annualCardExpiredTime: 0,
            isNewUserV3: false,
            isNewUserV4: false,
            isOpenedContinuousMonth: false,
            isPostponedCycleContract: false,
            familyInfo: null,
            currentValidityStartTime: 0,
            firstOpenAnnualCardMembershipTime: 0,
            isHasFreeCardPermission: false,
            freeCardExpiredTime: 0,
            canClaimFreeCard: false,
            isStreamerMembership: false,
            freeCardType: 0,
            membershipRedPacketType: 0,
            doesHavePhoneBillClaimPermission: false,
            membershipAttrs: null,
            canBuySaveMoneyCard: false,
            isSaveMoneyCardPermission: false,
            isSaveMoneyCardElemeMembershipType: false,
            nextPayIsFirstRenewal: false,
            renewalTimes: 0,
            maxRenewalTimesAllowed: 0,
            isQuickSaveMoneyCardPermission: false,
        };

        if (message.userID != null) {
            object.userID = message.userID;
        }
        if (message.status != null) {
            object.status = message.status;
        }
        if (message.openedTime != null) {
            object.openedTime = parseInt(message.openedTime, 10);
        }
        if (message.expiredTime != null) {
            object.expiredTime = parseInt(message.expiredTime, 10);
        }
        if (message.expiredDays != null) {
            object.expiredDays = parseInt(message.expiredDays, 10);
        }
        if (message.memberPrice != null) {
            object.memberPrice = MemberPriceV2.decode(message.memberPrice);
        }
        if (message.isNewUser != null) {
            object.isNewUser = message.isNewUser;
        }
        if (message.isShowDiscount85 != null) {
            object.isShowDiscount85 = message.isShowDiscount85;
        }
        if (message.isHasAnnualCardPermission != null) {
            object.isHasAnnualCardPermission = message.isHasAnnualCardPermission;
        }
        if (message.annualCardExpiredTime != null) {
            object.annualCardExpiredTime = parseInt(message.annualCardExpiredTime, 10);
        }
        if (message.isNewUserV3 != null) {
            object.isNewUserV3 = message.isNewUserV3;
        }
        if (message.isNewUserV4 != null) {
            object.isNewUserV4 = message.isNewUserV4;
        }
        if (message.isOpenedContinuousMonth != null) {
            object.isOpenedContinuousMonth = message.isOpenedContinuousMonth;
        }
        if (message.isPostponedCycleContract != null) {
            object.isPostponedCycleContract = message.isPostponedCycleContract;
        }
        if (message.familyInfo != null) {
            object.familyInfo = FamilyInfoV2.decode(message.familyInfo);
        }
        if (message.currentValidityStartTime != null) {
            object.currentValidityStartTime = parseInt(message.currentValidityStartTime, 10);
        }
        if (message.firstOpenAnnualCardMembershipTime != null) {
            object.firstOpenAnnualCardMembershipTime = parseInt(message.firstOpenAnnualCardMembershipTime, 10);
        }
        if (message.isHasFreeCardPermission != null) {
            object.isHasFreeCardPermission = message.isHasFreeCardPermission;
        }
        if (message.freeCardExpiredTime != null) {
            object.freeCardExpiredTime = parseInt(message.freeCardExpiredTime, 10);
        }
        if (message.canClaimFreeCard != null) {
            object.canClaimFreeCard = message.canClaimFreeCard;
        }
        if (message.isStreamerMembership != null) {
            object.isStreamerMembership = message.isStreamerMembership;
        }
        if (message.freeCardType != null) {
            object.freeCardType = message.freeCardType;
        }
        if (message.membershipRedPacketType != null) {
            object.membershipRedPacketType = message.membershipRedPacketType;
        }
        if (message.doesHavePhoneBillClaimPermission != null) {
            object.doesHavePhoneBillClaimPermission = message.doesHavePhoneBillClaimPermission;
        }
        if (message.membershipAttrs != null) {
            object.membershipAttrs = MembershipAttrs.decode(message.membershipAttrs);
        }
        if (message.canBuySaveMoneyCard != null) {
            object.canBuySaveMoneyCard = message.canBuySaveMoneyCard;
        }
        if (message.isSaveMoneyCardPermission != null) {
            object.isSaveMoneyCardPermission = message.isSaveMoneyCardPermission;
        }
        if (message.isSaveMoneyCardElemeMembershipType != null) {
            object.isSaveMoneyCardElemeMembershipType = message.isSaveMoneyCardElemeMembershipType;
        }
        if (message.nextPayIsFirstRenewal != null) {
            object.nextPayIsFirstRenewal = message.nextPayIsFirstRenewal;
        }
        if (message.renewalTimes != null) {
            object.renewalTimes = parseInt(message.renewalTimes, 10);
        }
        if (message.maxRenewalTimesAllowed != null) {
            object.maxRenewalTimesAllowed = parseInt(message.maxRenewalTimesAllowed, 10);
        }
        if (message.isQuickSaveMoneyCardPermission != null) {
            object.isQuickSaveMoneyCardPermission = message.isQuickSaveMoneyCardPermission;
        }
        return object;
    },
};

export const MembershipAttrs = {
    encode(object) {
        const message = {};
        if (object.hasOpenedSilverCard != null) {
            if (object.hasOpenedSilverCard !== false) {
                message.hasOpenedSilverCard = Boolean(object.hasOpenedSilverCard);
            }
        }
        if (object.hasOpenedGoldCard != null) {
            if (object.hasOpenedGoldCard !== false) {
                message.hasOpenedGoldCard = Boolean(object.hasOpenedGoldCard);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            hasOpenedSilverCard: false,
            hasOpenedGoldCard: false,
        };

        if (message.hasOpenedSilverCard != null) {
            object.hasOpenedSilverCard = message.hasOpenedSilverCard;
        }
        if (message.hasOpenedGoldCard != null) {
            object.hasOpenedGoldCard = message.hasOpenedGoldCard;
        }
        return object;
    },
};

export const MembershipInfo = {
    encode(object) {
        const message = {};
        if (object.userID != null) {
            if (object.userID !== "") {
                message.userID = String(object.userID);
            }
        }
        if (object.status != null) {
            if (object.status !== 0) {
                message.status = object.status;
            }
        }
        if (object.openedTime != null) {
            if (object.openedTime !== 0) {
                message.openedTime = object.openedTime | 0;
            }
        }
        if (object.expiredTime != null) {
            if (object.expiredTime !== 0) {
                message.expiredTime = object.expiredTime | 0;
            }
        }
        if (object.expiredDays != null) {
            if (object.expiredDays !== 0) {
                message.expiredDays = object.expiredDays | 0;
            }
        }
        if (object.memberPrice != null) {
            message.memberPrice = MemberPrice.encode(object.memberPrice);
        }
        if (object.isNewUser != null) {
            if (object.isNewUser !== false) {
                message.isNewUser = Boolean(object.isNewUser);
            }
        }
        if (object.isShowDiscount85 != null) {
            if (object.isShowDiscount85 !== false) {
                message.isShowDiscount85 = Boolean(object.isShowDiscount85);
            }
        }
        if (object.isHasAnnualCardPermission != null) {
            if (object.isHasAnnualCardPermission !== false) {
                message.isHasAnnualCardPermission = Boolean(object.isHasAnnualCardPermission);
            }
        }
        if (object.annualCardExpiredTime != null) {
            if (object.annualCardExpiredTime !== 0) {
                message.annualCardExpiredTime = object.annualCardExpiredTime | 0;
            }
        }
        if (object.isNewUserV3 != null) {
            if (object.isNewUserV3 !== false) {
                message.isNewUserV3 = Boolean(object.isNewUserV3);
            }
        }
        if (object.isNewUserV4 != null) {
            if (object.isNewUserV4 !== false) {
                message.isNewUserV4 = Boolean(object.isNewUserV4);
            }
        }
        if (object.isOpenedContinuousMonth != null) {
            if (object.isOpenedContinuousMonth !== false) {
                message.isOpenedContinuousMonth = Boolean(object.isOpenedContinuousMonth);
            }
        }
        if (object.isPostponedCycleContract != null) {
            if (object.isPostponedCycleContract !== false) {
                message.isPostponedCycleContract = Boolean(object.isPostponedCycleContract);
            }
        }
        if (object.familyInfo != null) {
            message.familyInfo = FamilyInfo.encode(object.familyInfo);
        }
        if (object.currentValidityStartTime != null) {
            if (object.currentValidityStartTime !== 0) {
                message.currentValidityStartTime = object.currentValidityStartTime | 0;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            userID: "",
            status: 0,
            openedTime: 0,
            expiredTime: 0,
            expiredDays: 0,
            memberPrice: null,
            isNewUser: false,
            isShowDiscount85: false,
            isHasAnnualCardPermission: false,
            annualCardExpiredTime: 0,
            isNewUserV3: false,
            isNewUserV4: false,
            isOpenedContinuousMonth: false,
            isPostponedCycleContract: false,
            familyInfo: null,
            currentValidityStartTime: 0,
        };

        if (message.userID != null) {
            object.userID = message.userID;
        }
        if (message.status != null) {
            object.status = message.status;
        }
        if (message.openedTime != null) {
            object.openedTime = message.openedTime;
        }
        if (message.expiredTime != null) {
            object.expiredTime = message.expiredTime;
        }
        if (message.expiredDays != null) {
            object.expiredDays = message.expiredDays;
        }
        if (message.memberPrice != null) {
            object.memberPrice = MemberPrice.decode(message.memberPrice);
        }
        if (message.isNewUser != null) {
            object.isNewUser = message.isNewUser;
        }
        if (message.isShowDiscount85 != null) {
            object.isShowDiscount85 = message.isShowDiscount85;
        }
        if (message.isHasAnnualCardPermission != null) {
            object.isHasAnnualCardPermission = message.isHasAnnualCardPermission;
        }
        if (message.annualCardExpiredTime != null) {
            object.annualCardExpiredTime = message.annualCardExpiredTime;
        }
        if (message.isNewUserV3 != null) {
            object.isNewUserV3 = message.isNewUserV3;
        }
        if (message.isNewUserV4 != null) {
            object.isNewUserV4 = message.isNewUserV4;
        }
        if (message.isOpenedContinuousMonth != null) {
            object.isOpenedContinuousMonth = message.isOpenedContinuousMonth;
        }
        if (message.isPostponedCycleContract != null) {
            object.isPostponedCycleContract = message.isPostponedCycleContract;
        }
        if (message.familyInfo != null) {
            object.familyInfo = FamilyInfo.decode(message.familyInfo);
        }
        if (message.currentValidityStartTime != null) {
            object.currentValidityStartTime = message.currentValidityStartTime;
        }
        return object;
    },
};

export const MemberPrice = {
    encode(object) {
        const message = {};
        if (object.isFirstOpened != null) {
            if (object.isFirstOpened !== false) {
                message.isFirstOpened = Boolean(object.isFirstOpened);
            }
        }
        if (object.price != null) {
            if (object.price !== 0) {
                message.price = object.price | 0;
            }
        }
        if (object.firstPrice != null) {
            if (object.firstPrice !== 0) {
                message.firstPrice = object.firstPrice | 0;
            }
        }
        if (object.isOnSale != null) {
            if (object.isOnSale !== false) {
                message.isOnSale = Boolean(object.isOnSale);
            }
        }
        if (object.firstPayType != null) {
            if (object.firstPayType !== 0) {
                message.firstPayType = object.firstPayType;
            }
        }
        if (object.subsidyAmount != null) {
            if (object.subsidyAmount !== 0) {
                message.subsidyAmount = object.subsidyAmount | 0;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            isFirstOpened: false,
            price: 0,
            firstPrice: 0,
            isOnSale: false,
            firstPayType: 0,
            subsidyAmount: 0,
        };

        if (message.isFirstOpened != null) {
            object.isFirstOpened = message.isFirstOpened;
        }
        if (message.price != null) {
            object.price = message.price;
        }
        if (message.firstPrice != null) {
            object.firstPrice = message.firstPrice;
        }
        if (message.isOnSale != null) {
            object.isOnSale = message.isOnSale;
        }
        if (message.firstPayType != null) {
            object.firstPayType = message.firstPayType;
        }
        if (message.subsidyAmount != null) {
            object.subsidyAmount = message.subsidyAmount;
        }
        return object;
    },
};

export const MemberPriceV2 = {
    encode(object) {
        const message = {};
        if (object.isFirstOpened != null) {
            if (object.isFirstOpened !== false) {
                message.isFirstOpened = Boolean(object.isFirstOpened);
            }
        }
        if (object.price != null) {
            if (object.price !== 0) {
                message.price = String(object.price);
            }
        }
        if (object.firstPrice != null) {
            if (object.firstPrice !== 0) {
                message.firstPrice = String(object.firstPrice);
            }
        }
        if (object.isOnSale != null) {
            if (object.isOnSale !== false) {
                message.isOnSale = Boolean(object.isOnSale);
            }
        }
        if (object.firstPayType != null) {
            if (object.firstPayType !== 0) {
                message.firstPayType = object.firstPayType;
            }
        }
        if (object.subsidyAmount != null) {
            if (object.subsidyAmount !== 0) {
                message.subsidyAmount = String(object.subsidyAmount);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            isFirstOpened: false,
            price: 0,
            firstPrice: 0,
            isOnSale: false,
            firstPayType: 0,
            subsidyAmount: 0,
        };

        if (message.isFirstOpened != null) {
            object.isFirstOpened = message.isFirstOpened;
        }
        if (message.price != null) {
            object.price = parseInt(message.price, 10);
        }
        if (message.firstPrice != null) {
            object.firstPrice = parseInt(message.firstPrice, 10);
        }
        if (message.isOnSale != null) {
            object.isOnSale = message.isOnSale;
        }
        if (message.firstPayType != null) {
            object.firstPayType = message.firstPayType;
        }
        if (message.subsidyAmount != null) {
            object.subsidyAmount = parseInt(message.subsidyAmount, 10);
        }
        return object;
    },
};

export const Package = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.name != null) {
            if (object.name !== "") {
                message.name = String(object.name);
            }
        }
        if (object.preferentialPrice != null) {
            if (object.preferentialPrice !== 0) {
                message.preferentialPrice = object.preferentialPrice | 0;
            }
        }
        if (object.originalPrice != null) {
            if (object.originalPrice !== 0) {
                message.originalPrice = object.originalPrice | 0;
            }
        }
        if (object.renewalPrice != null) {
            if (object.renewalPrice !== 0) {
                message.renewalPrice = object.renewalPrice | 0;
            }
        }
        if (object.discountTagDesc != null) {
            if (object.discountTagDesc !== "") {
                message.discountTagDesc = String(object.discountTagDesc);
            }
        }
        if (object.isFirstOpened != null) {
            if (object.isFirstOpened !== false) {
                message.isFirstOpened = Boolean(object.isFirstOpened);
            }
        }
        if (object.firstOpenedInfo != null) {
            message.firstOpenedInfo = FirstOpenedInfo.encode(object.firstOpenedInfo);
        }
        if (object.subsidyAmount != null) {
            if (object.subsidyAmount !== 0) {
                message.subsidyAmount = object.subsidyAmount | 0;
            }
        }
        if (object.subsidyDesc != null) {
            if (object.subsidyDesc !== "") {
                message.subsidyDesc = String(object.subsidyDesc);
            }
        }
        if (object.presentedDays != null) {
            if (object.presentedDays !== 0) {
                message.presentedDays = object.presentedDays | 0;
            }
        }
        if (object.packageType != null) {
            if (object.packageType !== 0) {
                message.packageType = object.packageType;
            }
        }
        if (object.allowanceAmount != null) {
            if (object.allowanceAmount !== 0) {
                message.allowanceAmount = object.allowanceAmount | 0;
            }
        }
        if (object.phoneBillAllowance != null) {
            if (object.phoneBillAllowance !== 0) {
                message.phoneBillAllowance = object.phoneBillAllowance | 0;
            }
        }
        if (object.lifeRightsCash != null) {
            if (object.lifeRightsCash !== 0) {
                message.lifeRightsCash = String(object.lifeRightsCash);
            }
        }
        if (object.phoneBillRedPacketAmount != null) {
            if (object.phoneBillRedPacketAmount !== 0) {
                message.phoneBillRedPacketAmount = String(object.phoneBillRedPacketAmount);
            }
        }
        if (object.shoppingCashRedPacketAmount != null) {
            if (object.shoppingCashRedPacketAmount !== 0) {
                message.shoppingCashRedPacketAmount = String(object.shoppingCashRedPacketAmount);
            }
        }
        if (object.takeoutLifeRightsRedPacketAmount != null) {
            if (object.takeoutLifeRightsRedPacketAmount !== 0) {
                message.takeoutLifeRightsRedPacketAmount = String(object.takeoutLifeRightsRedPacketAmount);
            }
        }
        if (object.isRenewPackage != null) {
            if (object.isRenewPackage !== false) {
                message.isRenewPackage = Boolean(object.isRenewPackage);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            name: "",
            preferentialPrice: 0,
            originalPrice: 0,
            renewalPrice: 0,
            discountTagDesc: "",
            isFirstOpened: false,
            firstOpenedInfo: null,
            subsidyAmount: 0,
            subsidyDesc: "",
            presentedDays: 0,
            packageType: 0,
            allowanceAmount: 0,
            phoneBillAllowance: 0,
            lifeRightsCash: 0,
            phoneBillRedPacketAmount: 0,
            shoppingCashRedPacketAmount: 0,
            takeoutLifeRightsRedPacketAmount: 0,
            isRenewPackage: false,
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.name != null) {
            object.name = message.name;
        }
        if (message.preferentialPrice != null) {
            object.preferentialPrice = message.preferentialPrice;
        }
        if (message.originalPrice != null) {
            object.originalPrice = message.originalPrice;
        }
        if (message.renewalPrice != null) {
            object.renewalPrice = message.renewalPrice;
        }
        if (message.discountTagDesc != null) {
            object.discountTagDesc = message.discountTagDesc;
        }
        if (message.isFirstOpened != null) {
            object.isFirstOpened = message.isFirstOpened;
        }
        if (message.firstOpenedInfo != null) {
            object.firstOpenedInfo = FirstOpenedInfo.decode(message.firstOpenedInfo);
        }
        if (message.subsidyAmount != null) {
            object.subsidyAmount = message.subsidyAmount;
        }
        if (message.subsidyDesc != null) {
            object.subsidyDesc = message.subsidyDesc;
        }
        if (message.presentedDays != null) {
            object.presentedDays = message.presentedDays;
        }
        if (message.packageType != null) {
            object.packageType = message.packageType;
        }
        if (message.allowanceAmount != null) {
            object.allowanceAmount = message.allowanceAmount;
        }
        if (message.phoneBillAllowance != null) {
            object.phoneBillAllowance = message.phoneBillAllowance;
        }
        if (message.lifeRightsCash != null) {
            object.lifeRightsCash = parseInt(message.lifeRightsCash, 10);
        }
        if (message.phoneBillRedPacketAmount != null) {
            object.phoneBillRedPacketAmount = parseInt(message.phoneBillRedPacketAmount, 10);
        }
        if (message.shoppingCashRedPacketAmount != null) {
            object.shoppingCashRedPacketAmount = parseInt(message.shoppingCashRedPacketAmount, 10);
        }
        if (message.takeoutLifeRightsRedPacketAmount != null) {
            object.takeoutLifeRightsRedPacketAmount = parseInt(message.takeoutLifeRightsRedPacketAmount, 10);
        }
        if (message.isRenewPackage != null) {
            object.isRenewPackage = message.isRenewPackage;
        }
        return object;
    },
};

export const FirstOpenedInfo = {
    encode(object) {
        const message = {};
        if (object.isOnSale != null) {
            if (object.isOnSale !== false) {
                message.isOnSale = Boolean(object.isOnSale);
            }
        }
        if (object.onSaleDesc != null) {
            if (object.onSaleDesc !== "") {
                message.onSaleDesc = String(object.onSaleDesc);
            }
        }
        if (object.cashBackDesc != null) {
            if (object.cashBackDesc !== "") {
                message.cashBackDesc = String(object.cashBackDesc);
            }
        }
        if (object.desc != null) {
            if (object.desc !== "") {
                message.desc = String(object.desc);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            isOnSale: false,
            onSaleDesc: "",
            cashBackDesc: "",
            desc: "",
        };

        if (message.isOnSale != null) {
            object.isOnSale = message.isOnSale;
        }
        if (message.onSaleDesc != null) {
            object.onSaleDesc = message.onSaleDesc;
        }
        if (message.cashBackDesc != null) {
            object.cashBackDesc = message.cashBackDesc;
        }
        if (message.desc != null) {
            object.desc = message.desc;
        }
        return object;
    },
};

export const UserInfo = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.phone != null) {
            if (object.phone !== "") {
                message.phone = String(object.phone);
            }
        }
        if (object.nickname != null) {
            if (object.nickname !== "") {
                message.nickname = String(object.nickname);
            }
        }
        if (object.avatar != null) {
            if (object.avatar !== "") {
                message.avatar = String(object.avatar);
            }
        }
        if (object.createdTime != null) {
            if (object.createdTime !== 0) {
                message.createdTime = object.createdTime | 0;
            }
        }
        if (object.updatedTime != null) {
            if (object.updatedTime !== 0) {
                message.updatedTime = object.updatedTime | 0;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            phone: "",
            nickname: "",
            avatar: "",
            createdTime: 0,
            updatedTime: 0,
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.phone != null) {
            object.phone = message.phone;
        }
        if (message.nickname != null) {
            object.nickname = message.nickname;
        }
        if (message.avatar != null) {
            object.avatar = message.avatar;
        }
        if (message.createdTime != null) {
            object.createdTime = message.createdTime;
        }
        if (message.updatedTime != null) {
            object.updatedTime = message.updatedTime;
        }
        return object;
    },
};

export const FamilyMemberInfo = {
    encode(object) {
        const message = {};
        if (object.userInfo != null) {
            message.userInfo = user_base_model.UserInfoPublicV2.encode(object.userInfo);
        }
        if (object.taskInfo != null) {
            message.taskInfo = quest_model.MembershipFamilyTaskInfo.encode(object.taskInfo);
        }
        if (object.registeredTime != null) {
            if (object.registeredTime !== 0) {
                message.registeredTime = object.registeredTime | 0;
            }
        }
        if (object.firstActiveTimeInApp != null) {
            if (object.firstActiveTimeInApp !== 0) {
                message.firstActiveTimeInApp = object.firstActiveTimeInApp | 0;
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            userInfo: null,
            taskInfo: null,
            registeredTime: 0,
            firstActiveTimeInApp: 0,
        };

        if (message.userInfo != null) {
            object.userInfo = user_base_model.UserInfoPublicV2.decode(message.userInfo);
        }
        if (message.taskInfo != null) {
            object.taskInfo = quest_model.MembershipFamilyTaskInfo.decode(message.taskInfo);
        }
        if (message.registeredTime != null) {
            object.registeredTime = message.registeredTime;
        }
        if (message.firstActiveTimeInApp != null) {
            object.firstActiveTimeInApp = message.firstActiveTimeInApp;
        }
        return object;
    },
};

export const FamilyMemberInfoV2 = {
    encode(object) {
        const message = {};
        if (object.userInfo != null) {
            message.userInfo = user_base_model.UserInfoPublicV2.encode(object.userInfo);
        }
        if (object.taskInfo != null) {
            message.taskInfo = quest_model.MembershipFamilyTaskInfo.encode(object.taskInfo);
        }
        if (object.registeredTime != null) {
            if (object.registeredTime !== 0) {
                message.registeredTime = String(object.registeredTime);
            }
        }
        if (object.firstActiveTimeInApp != null) {
            if (object.firstActiveTimeInApp !== 0) {
                message.firstActiveTimeInApp = String(object.firstActiveTimeInApp);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            userInfo: null,
            taskInfo: null,
            registeredTime: 0,
            firstActiveTimeInApp: 0,
        };

        if (message.userInfo != null) {
            object.userInfo = user_base_model.UserInfoPublicV2.decode(message.userInfo);
        }
        if (message.taskInfo != null) {
            object.taskInfo = quest_model.MembershipFamilyTaskInfo.decode(message.taskInfo);
        }
        if (message.registeredTime != null) {
            object.registeredTime = parseInt(message.registeredTime, 10);
        }
        if (message.firstActiveTimeInApp != null) {
            object.firstActiveTimeInApp = parseInt(message.firstActiveTimeInApp, 10);
        }
        return object;
    },
};

export const FamilyInfo = {
    encode(object) {
        const message = {};
        if (object.status != null) {
            if (object.status !== 0) {
                message.status = object.status;
            }
        }
        if (object.expiredTime != null) {
            if (object.expiredTime !== 0) {
                message.expiredTime = object.expiredTime | 0;
            }
        }
        if (object.inviterUserID != null) {
            if (object.inviterUserID !== "") {
                message.inviterUserID = String(object.inviterUserID);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            status: 0,
            expiredTime: 0,
            inviterUserID: "",
        };

        if (message.status != null) {
            object.status = message.status;
        }
        if (message.expiredTime != null) {
            object.expiredTime = message.expiredTime;
        }
        if (message.inviterUserID != null) {
            object.inviterUserID = message.inviterUserID;
        }
        return object;
    },
};

export const FamilyInfoV2 = {
    encode(object) {
        const message = {};
        if (object.status != null) {
            if (object.status !== 0) {
                message.status = object.status;
            }
        }
        if (object.expiredTime != null) {
            if (object.expiredTime !== 0) {
                message.expiredTime = String(object.expiredTime);
            }
        }
        if (object.inviterUserID != null) {
            if (object.inviterUserID !== "") {
                message.inviterUserID = String(object.inviterUserID);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            status: 0,
            expiredTime: 0,
            inviterUserID: "",
        };

        if (message.status != null) {
            object.status = message.status;
        }
        if (message.expiredTime != null) {
            object.expiredTime = parseInt(message.expiredTime, 10);
        }
        if (message.inviterUserID != null) {
            object.inviterUserID = message.inviterUserID;
        }
        return object;
    },
};

export const MembershipRightsSaveMoneyDesc = {
    encode(object) {
        const message = {};
        if (object.content != null) {
            if (object.content !== "") {
                message.content = String(object.content);
            }
        }
        if (object.contentStyleJSON != null) {
            if (object.contentStyleJSON !== "") {
                message.contentStyleJSON = String(object.contentStyleJSON);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            content: "",
            contentStyleJSON: "",
        };

        if (message.content != null) {
            object.content = message.content;
        }
        if (message.contentStyleJSON != null) {
            object.contentStyleJSON = message.contentStyleJSON;
        }
        return object;
    },
};

export const MembershipGroupbuyMember = {
    encode(object) {
        const message = {};
        if (object.userInfo != null) {
            message.userInfo = user_base_model.UserInfoPublicV2.encode(object.userInfo);
        }
        if (object.isStranger != null) {
            if (object.isStranger !== false) {
                message.isStranger = Boolean(object.isStranger);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            userInfo: null,
            isStranger: false,
        };

        if (message.userInfo != null) {
            object.userInfo = user_base_model.UserInfoPublicV2.decode(message.userInfo);
        }
        if (message.isStranger != null) {
            object.isStranger = message.isStranger;
        }
        return object;
    },
};

export const PhoneBillInfo = {
    encode(object) {
        const message = {};
        if (object.amount != null) {
            if (object.amount !== 0) {
                message.amount = String(object.amount);
            }
        }
        if (object.rateOfProgress != null) {
            if (object.rateOfProgress !== 0) {
                message.rateOfProgress = String(object.rateOfProgress);
            }
        }
        if (object.doesClaimed != null) {
            if (object.doesClaimed !== false) {
                message.doesClaimed = Boolean(object.doesClaimed);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            amount: 0,
            rateOfProgress: 0,
            doesClaimed: false,
        };

        if (message.amount != null) {
            object.amount = parseInt(message.amount, 10);
        }
        if (message.rateOfProgress != null) {
            object.rateOfProgress = parseInt(message.rateOfProgress, 10);
        }
        if (message.doesClaimed != null) {
            object.doesClaimed = message.doesClaimed;
        }
        return object;
    },
};

export const PaymentRecord = {
    encode(object) {
        const message = {};
        if (object.ID != null) {
            if (object.ID !== "") {
                message.ID = String(object.ID);
            }
        }
        if (object.userID != null) {
            if (object.userID !== "") {
                message.userID = String(object.userID);
            }
        }
        if (object.payOrderID != null) {
            if (object.payOrderID !== "") {
                message.payOrderID = String(object.payOrderID);
            }
        }
        if (object.clientIP != null) {
            if (object.clientIP !== "") {
                message.clientIP = String(object.clientIP);
            }
        }
        if (object.packageID != null) {
            if (object.packageID !== "") {
                message.packageID = String(object.packageID);
            }
        }
        if (object.paymentMethod != null) {
            if (object.paymentMethod !== 0) {
                message.paymentMethod = object.paymentMethod;
            }
        }
        if (object.createdTime != null) {
            if (object.createdTime !== 0) {
                message.createdTime = String(object.createdTime);
            }
        }
        if (object.updatedTime != null) {
            if (object.updatedTime !== 0) {
                message.updatedTime = String(object.updatedTime);
            }
        }
        return message;
    },

    decode(message) {
        const object = {
            ID: "",
            userID: "",
            payOrderID: "",
            clientIP: "",
            packageID: "",
            paymentMethod: 0,
            createdTime: 0,
            updatedTime: 0,
        };

        if (message.ID != null) {
            object.ID = message.ID;
        }
        if (message.userID != null) {
            object.userID = message.userID;
        }
        if (message.payOrderID != null) {
            object.payOrderID = message.payOrderID;
        }
        if (message.clientIP != null) {
            object.clientIP = message.clientIP;
        }
        if (message.packageID != null) {
            object.packageID = message.packageID;
        }
        if (message.paymentMethod != null) {
            object.paymentMethod = message.paymentMethod;
        }
        if (message.createdTime != null) {
            object.createdTime = parseInt(message.createdTime, 10);
        }
        if (message.updatedTime != null) {
            object.updatedTime = parseInt(message.updatedTime, 10);
        }
        return object;
    },
};

export const MembershipPaymentPackageInfo = {
    encode(object) {
        const message = {};
        if (object.paymentRecord != null) {
            message.paymentRecord = PaymentRecord.encode(object.paymentRecord);
        }
        if (object.package != null) {
            message.package = Package.encode(object.package);
        }
        return message;
    },

    decode(message) {
        const object = {
            paymentRecord: null,
            package: null,
        };

        if (message.paymentRecord != null) {
            object.paymentRecord = PaymentRecord.decode(message.paymentRecord);
        }
        if (message.package != null) {
            object.package = Package.decode(message.package);
        }
        return object;
    },
};


export const Status = {
    STATUS_UNDEFINED: 0,
    STATUS_NO_PERMISSION: 1,
    STATUS_NOT_OPENED: 2,
    STATUS_OPENED: 3,
    STATUS_EXPIRED: 4,
};


export const UserChannel = {
    USER_CHANNEL_UNDEFINED: 0,
    USER_CHANNEL_NORMAL: 1,
    USER_CHANNEL_PAGE_GUIDANCE: 2,
    USER_CHANNEL_1YUAN_BUY_CASH_PRINTER: 3,
};


export const MemberGroup = {
    MEMBER_GROUP_UNDEFINED: 0,
    MEMBER_GROUP_NORMAL: 1,
    MEMBER_GROUP_PAGE_GUIDANCE: 2,
    MEMBER_GROUP_PAGE_GUIDANCE_1990: 3,
};


export const RefundReason = {
    REFUND_REASON_UNDEFINED: 0,
    REFUND_REASON_OTHERS: 1,
    REFUND_REASON_1YUAN_BUY: 2,
    REFUND_REASON_ALLOWANCE: 3,
    REFUND_REASON_PHONE_BILL_ALLOWANCE: 4,
    REFUND_REASON_MEMBERSHIP_PERMISSION: 5,
    REFUND_REASON_ELEME: 6,
    REFUND_REASON_ACCOUNTING_ARRIVED_TOO_LATE: 7,
    REFUND_REASON_THIRD_PARTY_TRADING_PLATFORM: 8,
    REFUND_REASON_ITEM: 9,
    REFUND_REASON_MEMBERSHIP_FAMILY: 10,
    REFUND_REASON_1YUAN_BUY_BE_MISTAKEN_FOR_OPEN_MEMBERSHIP: 11,
    REFUND_REASON_1YUAN_BUY_SUBSIDY_TOO_LITTLE: 12,
    REFUND_REASON_1YUAN_BUY_MONTH_CARD_CANNOT_BUY_YEAR_CARD_ITEMS: 13,
    REFUND_REASON_1YUAN_BUY_DIRECT_TAOBAO_NEED_FULL_PAYMENT: 14,
    REFUND_REASON_1YUAN_BUY_ACCOUNTING_ARRIVED_TOO_LATE: 15,
    REFUND_REASON_1YUAN_BUY_ITEM_POOR_QUALITY: 16,
    REFUND_REASON_1YUAN_BUY_CAN_NOT_GET_SUBSIDY_AGAIN: 17,
    REFUND_REASON_OPERATION_COMPLICATED: 18,
    REFUND_REASON_TAOBAO_AUTHORIZED_FAILED: 19,
    REFUND_REASON_PHONE_BILL_ALLOWANCE_ORDER_CLOSED: 20,
    REFUND_REASON_PHONE_BILL_ALLOWANCE_HIGH_THRESHOLD_FOR_USE: 21,
    REFUND_REASON_PHONE_BILL_ALLOWANCE_CASH_BACK_FAILED: 22,
    REFUND_REASON_SHOPPING_SUBSIDY_PART_ITEM_EXPENSIVE: 23,
    REFUND_REASON_SHOPPING_SUBSIDY_PART_NOT_FOUND: 24,
    REFUND_REASON_SHOPPING_SUBSIDY_CAN_NOT_DEDUCT_FULL_PAYMENT: 25,
    REFUND_REASON_SHOPPING_SUBSIDY_CAN_NOT_WITHDRAW_DEPOSIT: 26,
    REFUND_REASON_MEMBERSHIP_PERMISSION_NOT_CLEAR: 27,
    REFUND_REASON_MEMBERSHIP_AUTO_DEDUCT_MONEY: 28,
    REFUND_REASON_MEMBERSHIP_FAMILY_CAN_NOT_BE_FAMILY_MEMBER: 29,
    REFUND_REASON_MEMBERSHIP_FAMILY_PERMISSION_NOT_CLEAR: 30,
};


export const PayOrderStatus = {
    PAY_ORDER_STATUS_UNDEFINED: 0,
    PAY_ORDER_STATUS_SUCCESS: 1,
    PAY_ORDER_STATUS_FAIL: 2,
    PAY_ORDER_STATUS_PAYING: 3,
    PAY_ORDER_STATUS_EXPIRED: 4,
    PAY_ORDER_STATUS_NOT_EXIST: 5,
};


export const AlipayCyclePayContractStatus = {
    ALIPAY_CYCLE_PAY_CONTRACT_STATUS_UNDEFINED: 0,
    ALIPAY_CYCLE_PAY_CONTRACT_STATUS_CREATED: 1,
    ALIPAY_CYCLE_PAY_CONTRACT_STATUS_SIGNED: 2,
    ALIPAY_CYCLE_PAY_CONTRACT_STATUS_CANCELED: 3,
    ALIPAY_CYCLE_PAY_CONTRACT_STATUS_POSTPONED: 4,
};


export const WechatAppCyclePayContractStatus = {
    WECHAT_APP_CYCLE_PAY_CONTRACT_STATUS_UNDEFINED: 0,
    WECHAT_APP_CYCLE_PAY_CONTRACT_STATUS_CREATED: 1,
    WECHAT_APP_CYCLE_PAY_CONTRACT_STATUS_SIGNED: 2,
    WECHAT_APP_CYCLE_PAY_CONTRACT_STATUS_CANCELED: 3,
    WECHAT_APP_CYCLE_PAY_CONTRACT_STATUS_POSTPONED: 4,
};


export const PayType = {
    PAY_TYPE_UNDEFINED: 0,
    PAY_TYPE_CASH: 1,
    PAY_TYPE_MIAO_COIN: 2,
    PAY_TYPE_FREE_CARD: 3,
    PAY_TYPE_FREE_UPGRADE_SILVER_TAILSMAN: 4,
    PAY_TYPE_FREE_UPGRADE_GOLD_TAILSMAN: 5,
    PAY_TYPE_STREAMER_MEMBERSHIP: 6,
    PAY_TYPE_PHONE_BILL_GIFT_MEMBERSHIP: 7,
    PAY_TYPE_PHONE_CHARGE_MEMBERSHIP: 8,
    PAY_TYPE_OFFICIAL_ITEM_CHARGE_MEMBERSHIP: 9,
};


export const RefundStatus = {
    REFUND_STATUS_UNDEFINED: 0,
    REFUND_STATUS_REFUNDING: 1,
    REFUND_STATUS_SUCCESSED: 2,
    REFUND_STATUS_FAILED: 3,
};


export const BindFamilyRelationStatus = {
    BIND_FAMILY_RELATION_STATUS_UNDEFINED: 0,
    BIND_FAMILY_RELATION_STATUS_BINDING: 1,
    BIND_FAMILY_RELATION_STATUS_SUCCESSED: 2,
    BIND_FAMILY_RELATION_STATUS_FAILED: 3,
};


export const PackageType = {
    PACKAGE_TYPE_UNDEFINED: 0,
    PACKAGE_TYPE_MONTH: 1,
    PACKAGE_TYPE_SEASON: 2,
    PACKAGE_TYPE_HALF_YEAR: 3,
    PACKAGE_TYPE_YEAR: 4,
    PACKAGE_TYPE_CONTINUOUS_MONTH: 5,
    PACKAGE_TYPE_FREE_CARD: 6,
    PACKAGE_TYPE_SILVER_TAILSMAN: 7,
    PACKAGE_TYPE_GOLD_TAILSMAN: 8,
    PACKAGE_TYPE_STREAMER_MEMBERSHIP: 9,
    PACKAGE_TYPE_SAVE_MONEY_CARD: 10,
    PACKAGE_TYPE_SAVE_MONEY_CARD_1990: 11,
    PACKAGE_TYPE_QUICK_SAVE_MONEY_CARD: 12,
};


export const ExchargeType = {
    EXCHARGE_TYPE_UNDEFINED: 0,
    EXCHARGE_TYPE_MIAO_COIN: 1,
    EXCHARGE_TYPE_ENTRY_CARD: 2,
    EXCHARGE_TYPE_MIDU_MIAO_TOKEN: 3,
    EXCHARGE_TYPE_FREE_CARD: 4,
    EXCHARGE_TYPE_FREE_UPGRADE_SILVER_TAILSMAN: 5,
    EXCHARGE_TYPE_FREE_UPGRADE_GOLD_TAILSMAN: 6,
    EXCHARGE_TYPE_STREAMER_MEMBERSHIP: 7,
    EXCHARGE_TYPE_FREE_CARD_EXPIRED_AUTO_DEDUCT: 8,
    EXCHARGE_TYPE_GOLD_TAILSMAN_REFUND_DEGRADE_SILVER_TAILSMAN: 9,
    EXCHARGE_TYPE_SILVER_TAILSMAN_ENTRY_CARD: 10,
    EXCHARGE_TYPE_SAVE_MONEY_CARD_FREE_CARD: 11,
    EXCHARGE_TYPE_PHONE_CHARGE_MEMBERSHIP: 12,
    EXCHARGE_TYPE_OFFICIAL_ITEM_CHARGE_MEMBERSHIP: 13,
};


export const SourceType = {
    SOURCE_TYPE_UNDEFINED: 0,
    SOURCE_TYPE_ORDER_ID: 1,
};


export const FamilyStatus = {
    FAMILY_STATUS_UNDEFINED: 0,
    FAMILY_STATUS_NOT_OPENED: 1,
    FAMILY_STATUS_OPENED: 2,
    FAMILY_STATUS_EXPIRED: 3,
};


export const PaymentMethod = {
    PAYMENT_METHOD_UNDEFINED: 0,
    PAYMENT_METHOD_WEIXIN: 1,
    PAYMENT_METHOD_ALIPAY: 2,
    PAYMENT_METHOD_MIAO_COIN: 3,
    PAYMENT_METHOD_ENTRY_CARD: 4,
    PAYMENT_METHOD_FREE_UPGRADE_SILVER_TAILSMAN: 5,
    PAYMENT_METHOD_FREE_UPGRADE_GOLD_TAILSMAN: 6,
    PAYMENT_METHOD_GOLD_TAILSMAN_REFUND_DEGRADE_SILVER_TAILSMAN: 7,
    PAYMENT_METHOD_PHONE_CHARGE_MEMBERSHIP: 8,
    PAYMENT_METHOD_OFFICIAL_ITEM_CHARGE_MEMBERSHIP: 9,
};


export const MembershipGroupbuyType = {
    MEMBERSHIP_GROUPBUY_TYPE_UNDEFINED: 0,
    MEMBERSHIP_GROUPBUY_TYPE_NUMBER_TWO: 1,
    MEMBERSHIP_GROUPBUY_TYPE_NUMBER_THREE: 2,
};


export const MembershipGroupbuyStatus = {
    MEMBERSHIP_GROUPBUY_STATUS_UNDEFINED: 0,
    MEMBERSHIP_GROUPBUY_STATUS_PENDING: 1,
    MEMBERSHIP_GROUPBUY_STATUS_SUCCESSED: 2,
    MEMBERSHIP_GROUPBUY_STATUS_FAILED: 3,
};


export const MembershipGroupbuyRole = {
    MEMBERSHIP_GROUPBUY_ROLE_UNDEFINED: 0,
    MEMBERSHIP_GROUPBUY_ROLE_NEW_USER: 1,
    MEMBERSHIP_GROUPBUY_ROLE_NORMAL_USER: 2,
    MEMBERSHIP_GROUPBUY_ROLE_MEMBERSHIP: 3,
};


export const MembershipChannel = {
    MEMBERSHIP_CHANNEL_UNDEFINED: 0,
    MEMBERSHIP_CHANNEL_MIDU: 1,
};


export const FreeMembershipType = {
    FREE_MEMBERSHIP_TYPE_UNDEFINED: 0,
    FREE_MEMBERSHIP_TYPE_THREE_DAYS: 1,
    FREE_MEMBERSHIP_TYPE_THREE_DAYS_EXPIRED_AUTO_DEDUCT: 2,
    FREE_MEMBERSHIP_TYPE_SEVEN_DAYS: 3,
    FREE_MEMBERSHIP_TYPE_THIRTY_DAYS: 4,
};


export const MembershipRedPacketType = {
    MEMBERSHIP_RED_PACKET_TYPE_UNDEFINED: 0,
    MEMBERSHIP_RED_PACKET_TYPE_PAYOFF: 1,
    MEMBERSHIP_RED_PACKET_TYPE_RETURNING_OPEN_FEE: 2,
};


